module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Peter Legaard Nielsen, born in 1960, is a Danish author, who made his debut with a poetry collection, "), _c('em', [_vm._v("The Bloody Temple of the Heart")]), _vm._v(", in 1985 and had his breakthrough with the novel, "), _c('em', [_vm._v("While the Sun Slowly Burns Up")]), _vm._v(", in 1987. "), _c('em', [_vm._v("Darkness Without Limits")]), _vm._v(" is his second novel. He has published 9 novels and 2 poetry collections and edited a large number of anthologies.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("He was chairman of the Danish Fiction Writers Association from 1997–2001 and from 2002–2007. In 1992, he was awarded a 3-year grant from the state’s Art Fund. He was a literary reviewer at a newspaper from 1987 to 1992.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Peter is also an Authorized Advanced Rolfer™ and an Authorized Level 3 IFS Practitioner.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0235a5e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0